import { useState } from 'react';
import { podiumData } from '../../../mocks/roadmapData';

export default function PodiumLeaseTable() {
  const [selectedFloor, setSelectedFloor] = useState('B1');

  const currentFloor = podiumData.floors.find(f => f.floor === selectedFloor);

  return (
    <section className="py-24 bg-gradient-to-br from-slate-50 via-white to-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* 헤더 */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-500 rounded-2xl mb-6">
            <i className="ri-store-3-line text-3xl text-white"></i>
          </div>
          <h2 className="text-4xl font-bold text-slate-900 mb-4">
            상업시설 포디움 임대 계획
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            지하 1층부터 지상 4층까지 총 5개 층의 상업시설 구성 및 임대 조건
          </p>
        </div>

        {/* 요약 카드 */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-12">
          <div className="bg-white rounded-2xl p-6 shadow-lg border border-slate-200">
            <div className="flex items-center justify-between mb-3">
              <i className="ri-building-4-line text-3xl text-purple-500"></i>
              <span className="text-sm font-semibold text-purple-600 bg-purple-50 px-3 py-1 rounded-full whitespace-nowrap">
                총 층수
              </span>
            </div>
            <div className="text-3xl font-bold text-slate-900 mb-1">5개 층</div>
            <div className="text-sm text-slate-600">B1 ~ 4F</div>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-lg border border-slate-200">
            <div className="flex items-center justify-between mb-3">
              <i className="ri-layout-grid-line text-3xl text-pink-500"></i>
              <span className="text-sm font-semibold text-pink-600 bg-pink-50 px-3 py-1 rounded-full whitespace-nowrap">
                총 면적
              </span>
            </div>
            <div className="text-3xl font-bold text-slate-900 mb-1">{podiumData.summary.totalArea}</div>
            <div className="text-sm text-slate-600">전용면적 기준</div>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-lg border border-slate-200">
            <div className="flex items-center justify-between mb-3">
              <i className="ri-money-dollar-circle-line text-3xl text-emerald-500"></i>
              <span className="text-sm font-semibold text-emerald-600 bg-emerald-50 px-3 py-1 rounded-full whitespace-nowrap">
                연간 수입
              </span>
            </div>
            <div className="text-3xl font-bold text-slate-900 mb-1">{podiumData.summary.annualRevenue}</div>
            <div className="text-sm text-slate-600">월세 기준 예상</div>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-lg border border-slate-200">
            <div className="flex items-center justify-between mb-3">
              <i className="ri-percent-line text-3xl text-cyan-500"></i>
              <span className="text-sm font-semibold text-cyan-600 bg-cyan-50 px-3 py-1 rounded-full whitespace-nowrap">
                평균 수익률
              </span>
            </div>
            <div className="text-3xl font-bold text-slate-900 mb-1">{podiumData.summary.avgYield}</div>
            <div className="text-sm text-slate-600">연 임대수익률</div>
          </div>
        </div>

        {/* 층별 탭 */}
        <div className="bg-white rounded-2xl shadow-lg border border-slate-200 p-8 mb-8">
          <h3 className="text-2xl font-bold text-slate-900 mb-6">층별 상세 정보</h3>
          
          <div className="flex flex-wrap gap-3 mb-8">
            {podiumData.floors.map((floor) => (
              <button
                key={floor.floor}
                onClick={() => setSelectedFloor(floor.floor)}
                className={`px-6 py-3 rounded-xl font-semibold transition-all whitespace-nowrap ${
                  selectedFloor === floor.floor
                    ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-lg scale-105'
                    : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
                }`}
              >
                {floor.floor}
              </button>
            ))}
          </div>

          {currentFloor && (
            <div className="space-y-6">
              {/* 층 정보 카드 */}
              <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-6 border border-purple-200">
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h4 className="text-2xl font-bold text-slate-900 mb-2">{currentFloor.floor}</h4>
                    <p className="text-lg text-slate-700 font-semibold">{currentFloor.usage}</p>
                  </div>
                  <div className="text-right">
                    <div className="text-sm text-slate-600 mb-1">전용면적</div>
                    <div className="text-2xl font-bold text-purple-600">{currentFloor.area}</div>
                  </div>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
                  <div className="bg-white rounded-lg p-4">
                    <div className="text-sm text-slate-600 mb-1">보증금</div>
                    <div className="text-xl font-bold text-slate-900">{currentFloor.deposit}</div>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <div className="text-sm text-slate-600 mb-1">월 임대료</div>
                    <div className="text-xl font-bold text-slate-900">{currentFloor.monthlyRent}</div>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <div className="text-sm text-slate-600 mb-1">연간 수입</div>
                    <div className="text-xl font-bold text-emerald-600">{currentFloor.annualRevenue}</div>
                  </div>
                </div>

                <div className="mt-6 pt-6 border-t border-purple-200">
                  <div className="text-sm font-semibold text-slate-700 mb-3">입점 가능 업종</div>
                  <div className="flex flex-wrap gap-2">
                    {currentFloor.categories.map((cat, idx) => (
                      <span
                        key={idx}
                        className="px-4 py-2 bg-white text-slate-700 rounded-lg text-sm font-medium border border-slate-200"
                      >
                        {cat}
                      </span>
                    ))}
                  </div>
                </div>

                {currentFloor.note && (
                  <div className="mt-4 flex items-start gap-3 bg-white rounded-lg p-4">
                    <i className="ri-information-line text-xl text-purple-500 mt-0.5"></i>
                    <p className="text-sm text-slate-600">{currentFloor.note}</p>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* 전체 층 통합 테이블 */}
        <div className="bg-white rounded-2xl shadow-lg border border-slate-200 p-8 mb-8">
          <h3 className="text-2xl font-bold text-slate-900 mb-6">전체 층별 임대 조건 요약</h3>
          
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gradient-to-r from-purple-50 to-pink-50 border-b-2 border-purple-200">
                  <th className="px-6 py-4 text-left text-sm font-bold text-slate-900">층</th>
                  <th className="px-6 py-4 text-left text-sm font-bold text-slate-900">용도</th>
                  <th className="px-6 py-4 text-right text-sm font-bold text-slate-900">전용면적</th>
                  <th className="px-6 py-4 text-right text-sm font-bold text-slate-900">보증금</th>
                  <th className="px-6 py-4 text-right text-sm font-bold text-slate-900">월 임대료</th>
                  <th className="px-6 py-4 text-right text-sm font-bold text-slate-900">연간 수입</th>
                  <th className="px-6 py-4 text-left text-sm font-bold text-slate-900">비고</th>
                </tr>
              </thead>
              <tbody>
                {podiumData.floors.map((floor, idx) => (
                  <tr
                    key={floor.floor}
                    className={`border-b border-slate-200 hover:bg-slate-50 transition-colors cursor-pointer ${
                      selectedFloor === floor.floor ? 'bg-purple-50' : ''
                    }`}
                    onClick={() => setSelectedFloor(floor.floor)}
                  >
                    <td className="px-6 py-4 text-sm font-bold text-slate-900">{floor.floor}</td>
                    <td className="px-6 py-4 text-sm text-slate-700">{floor.usage}</td>
                    <td className="px-6 py-4 text-sm text-slate-900 text-right font-semibold">{floor.area}</td>
                    <td className="px-6 py-4 text-sm text-slate-900 text-right">{floor.deposit}</td>
                    <td className="px-6 py-4 text-sm text-slate-900 text-right">{floor.monthlyRent}</td>
                    <td className="px-6 py-4 text-sm text-emerald-600 text-right font-semibold">{floor.annualRevenue}</td>
                    <td className="px-6 py-4 text-sm text-slate-600">{floor.tableNote || '-'}</td>
                  </tr>
                ))}
                <tr className="bg-gradient-to-r from-purple-100 to-pink-100 font-bold">
                  <td className="px-6 py-4 text-sm text-slate-900" colSpan={2}>합계</td>
                  <td className="px-6 py-4 text-sm text-slate-900 text-right">{podiumData.summary.totalArea}</td>
                  <td className="px-6 py-4 text-sm text-slate-900 text-right">-</td>
                  <td className="px-6 py-4 text-sm text-slate-900 text-right">-</td>
                  <td className="px-6 py-4 text-sm text-emerald-600 text-right font-bold">{podiumData.summary.annualRevenue}</td>
                  <td className="px-6 py-4"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* 층별 임대수입 비중 차트 */}
        <div className="bg-white rounded-2xl shadow-lg border border-slate-200 p-8 mb-8">
          <h3 className="text-2xl font-bold text-slate-900 mb-6">층별 임대수입 비중</h3>
          
          <div className="space-y-4">
            {podiumData.floors.map((floor, idx) => {
              const colors = ['bg-purple-500', 'bg-pink-500', 'bg-rose-500', 'bg-fuchsia-500', 'bg-violet-500'];
              const bgColors = ['bg-purple-50', 'bg-pink-50', 'bg-rose-50', 'bg-fuchsia-50', 'bg-violet-50'];
              
              return (
                <div key={floor.floor} className={`${bgColors[idx]} rounded-xl p-4`}>
                  <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center gap-3">
                      <span className="font-bold text-slate-900">{floor.floor}</span>
                      <span className="text-sm text-slate-600">{floor.usage}</span>
                    </div>
                    <div className="flex items-center gap-4">
                      <span className="text-sm font-semibold text-slate-900">{floor.annualRevenue}</span>
                      <span className="text-sm font-bold text-purple-600">{floor.revenueShare}</span>
                    </div>
                  </div>
                  <div className="w-full bg-white rounded-full h-3 overflow-hidden">
                    <div
                      className={`${colors[idx]} h-full rounded-full transition-all duration-500`}
                      style={{ width: floor.revenueShare }}
                    ></div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* 임대 조건 안내 */}
        <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-8 border border-amber-200">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-amber-500 rounded-xl flex items-center justify-center flex-shrink-0">
              <i className="ri-information-line text-2xl text-white"></i>
            </div>
            <div>
              <h4 className="text-xl font-bold text-slate-900 mb-4">임대 조건 안내</h4>
              <ul className="space-y-2 text-sm text-slate-700">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-amber-500 mt-0.5"></i>
                  <span><strong>관리비:</strong> 월 임대료와 별도로 부과 (평당 약 15,000원 예상)</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-amber-500 mt-0.5"></i>
                  <span><strong>부가세(VAT):</strong> 월 임대료의 10% 별도</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-amber-500 mt-0.5"></i>
                  <span><strong>계약기간:</strong> 최소 3년 이상 (협의 가능)</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-amber-500 mt-0.5"></i>
                  <span><strong>임대료 인상:</strong> 연 5% 이내 (물가상승률 연동)</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-amber-500 mt-0.5"></i>
                  <span><strong>입점 시기:</strong> 2028년 6월 준공 후 순차 입점 예정</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-amber-500 mt-0.5"></i>
                  <span><strong>인테리어:</strong> 기본 마감 제공, 업종별 추가 인테리어는 임차인 부담</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}